import Vue from 'vue';

export default () => {
  Vue.filter('formatFiatAmount', function (fiatAmount: number) {
    if (!fiatAmount) return '0';
    const formattedAmount = `${fiatAmount.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
    if (formattedAmount.includes('.00')) return formattedAmount.split('.')[0];
    else return formattedAmount;
  });
};
